import React                                from 'react';
import { Prompt }                           from 'react-router-dom';
import {
  branch,
  compose,
  mapProps,
  renderNothing,
  setDisplayName,
  wrapDisplayName
}                                           from 'recompose';
import _                                    from 'underscore';
import mapEditableContent, {
  PROP_BEGIN_EDITING,
  PROP_EDITABLE_CONTENT,
  PROP_EDITED_CONTENT,
  PROP_EDITED_CONTENT_NAMES,
  PROP_END_EDITING,
  PROP_HAS_EDITABLE_CONTENT,
  PROP_HAS_EDITED_CONTENT,
}                                           from './mapEditableContent';
import mapInEditMode, { PROP_IN_EDIT_MODE } from './mapInEditMode';


const PresentationComponent = setDisplayName('EditToggle')(
  ({prompt, text, toggleEditing, ...props}) => <span {...props}>

    {prompt}

    <span onClick={toggleEditing}>{text}</span>

  </span>
);


const EditToggle = compose(
  mapInEditMode({innerComponent: PresentationComponent}),

  mapEditableContent({innerComponent: PresentationComponent}),

  setDisplayName(wrapDisplayName(PresentationComponent, 'HideIfNoEditableContent')),
  branch(
    props => !props[PROP_HAS_EDITABLE_CONTENT],
    renderNothing
  ),

  setDisplayName(wrapDisplayName(PresentationComponent, 'MapOnlyPresentationProps')),
  mapProps(
    ({
       [PROP_IN_EDIT_MODE]:         inEditMode,
       [PROP_HAS_EDITED_CONTENT]:   hasEdits,
       [PROP_EDITED_CONTENT]:       edits,
       [PROP_EDITED_CONTENT_NAMES]: editNames,
       [PROP_BEGIN_EDITING]:        beginEditing,
       [PROP_END_EDITING]:          endEditing,

       ...props
     }) => {

      return _.omit(
        Object.assign({}, props, {
          prompt:        <Prompt when={!!editNames.count()} message={getCancelMessage(editNames)}/>,
          text:          !inEditMode ? 'Begin editing' : 'Finish editing',
          toggleEditing: getToggleEditingPropWithUnsavedCheck({
            inEditMode,
            hasEdits,
            editNames,
            beginEditing,
            endEditing
          }),
        }),
        // Omit
        [PROP_HAS_EDITABLE_CONTENT, PROP_EDITABLE_CONTENT]
      );
    }
  ),
)(PresentationComponent);


const getCancelMessage = (editNames) =>
  "The following fields have not been saved.  Are you sure you want to cancel these changes?\n\n- " +
  Object.values(editNames.toJS()).join("\n- ");


const getToggleEditingPropWithUnsavedCheck = ({inEditMode, hasEdits, editNames, beginEditing, endEditing}) => {

  if (!inEditMode) {

    return beginEditing;

  }

  if (!hasEdits) {

    return endEditing;

  }

  return () => {

    if (window.confirm(getCancelMessage(editNames))) {

      endEditing();

    }

  };

};


export default EditToggle;


// WEBPACK FOOTER //
// ./src/modules/editableContent/components/EditToggle.js